import { render, staticRenderFns } from "./PersonSettingComponent.vue?vue&type=template&id=8e1dd8bc"
import script from "./PersonSettingComponent.vue?vue&type=script&lang=js"
export * from "./PersonSettingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports